// odometer https://github.com/HubSpot/odometer

import Odometer from 'odometer';
import { TweenMax } from 'gsap';
import ScrollMagic from 'scrollmagic';

const odometerAction = () => {
  const $elements = $('.odometer');
  if ($elements.length) {
    TweenMax.set($elements.parent('.odo-text'), { opacity: 0 });
    const oddController = new ScrollMagic.Controller();

    $elements.each((i, el) => {
      const count = $(el).attr('data-od')
      const od = new Odometer({
        el: el,
        value: count,
      });
      new ScrollMagic
        .Scene({
          triggerElement: '.odometer',
          triggerHook: 0.78,
          reverse: true,
        })
        .addTo(oddController)
        .triggerHook(0.7)
        .on('enter', () => {
          $(el).html(0);
          $(el).html(count);
          TweenMax.to($elements.parent('.odo-text'), 0.5, { opacity: 1 });
          // this.remove();
        });
    });
  }
};

export default odometerAction;



// WEBPACK FOOTER //
// ./src/scripts/common/odometerAction.js